// src/games/pacman-Amazon/systems/AudioSystem.ts
import {
  AudioSystem as SharedAudioSystem,
  AudioConfig,
} from '../../../engine/ecs/systems/AudioSystem';
import { ResourceManager } from '../../../engine/resources/ResourceManager';

// Amazon-specific audio configuration
const AMAZON_AUDIO_CONFIG: AudioConfig = {
  // superpowerBackgroundMusic: 'super_power_background.wav', // No longer needed - default matches!

  soundVolume: 0.6,
  musicVolume: 0.4,
  enableSuperpowerMusic: true,
  enableSoundEffects: true,
  enableBackgroundMusic: true,
};

export class AudioSystem extends SharedAudioSystem {
  constructor(resourceManager: ResourceManager) {
    super(resourceManager, AMAZON_AUDIO_CONFIG);
  }
}
